var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('bannera'),_c('contenta',{attrs:{"routerPath":_vm.routerPath}}),_c('footera')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }